import { Task } from "../../types/tasks";

export const WEBSOCKET_CLOSE_CODES = {
  NORMAL_CLOSURE: 1000,
} as const;

export type TaskBoardConnectionState =
  | "connecting"
  | "connected"
  | "disconnected"
  | "error"
  | "reconnecting";

export interface TaskBoardWebSocketMessage {
  type: "tasks";
  data: Task[];
  count: number;
  companyId: string;
  timestamp: number;
}

export interface TaskBoardWebSocketEvent {
  type: "message" | "connection" | "error";
  data: TaskBoardWebSocketMessage | { connected: boolean } | { error: Error };
}

export interface TaskBoardConnectionOptions {
  companyId: string;
  onMessage: (message: TaskBoardWebSocketMessage) => void;
  onConnectionChange?: (connected: boolean) => void;
  onError?: (error: Error) => void;
  onStateChange?: (state: TaskBoardConnectionState) => void;
}

export interface ReconnectionConfig {
  maxAttempts: number;
  initialDelay: number;
  maxDelay: number;
  backoffMultiplier: number;
  jitter: boolean;
}

export class TaskBoardWebSocketError extends Error {
  public readonly code: string;
  public readonly isRetryable: boolean;

  constructor(
    message: string,
    code: string = "UNKNOWN_ERROR",
    isRetryable: boolean = true,
  ) {
    super(message);
    this.name = "TaskBoardWebSocketError";
    this.code = code;
    this.isRetryable = isRetryable;
  }
}

export type MessageType = "task" | "workflow";

export interface UnifiedMessage<T> {
  type: MessageType;
  payload: T;
}
